import {FC, useCallback, useMemo} from 'react';
import {styled} from 'styled-components';
import {useParams} from 'wouter';

import {GroupType} from '@shared/models/api_models';

import {Button} from '@shared_web/components/core/button';
import {showSuccess} from '@shared_web/components/core/notifications';
import {notifyError} from '@shared_web/lib/notification';

import {translate, Translate} from '@mavismart_frontend/components/translate';
import {apiCall} from '@mavismart_frontend/lib/api';
import {BUTTON_THEME2} from '@mavismart_frontend/lib/constants';
import {getUserLanguage, useAccount} from '@mavismart_frontend/stores/account_store';
import {removeDoorFromGroup, useGroups} from '@mavismart_frontend/stores/groups_store';

interface RemoveDoorFromCustomGroupProps {
  doorId: string;
}

export const RemoveDoorFromCustomGroup: FC<RemoveDoorFromCustomGroupProps> = ({doorId}) => {
  const account = useAccount();
  const {groupId} = useParams<{groupId?: string}>();

  const fullGroups = useGroups();

  // Find the current group based on groupId from params and filtered by custom groups
  const currentGroup = useMemo(() => {
    if (!fullGroups) {
      return;
    }
    return fullGroups.find(g => g.group.id === groupId && g.group.type === GroupType.Manual);
  }, [groupId, fullGroups]);

  const handleRemoveDoorFromCustomGroup = useCallback(async () => {
    if (!groupId) {
      return;
    }

    try {
      apiCall('POST /remove-door-from-custom-group', {
        doorId,
        groupId,
      });
      showSuccess(translate('door_removed_from_custom_group', getUserLanguage(account)));
      removeDoorFromGroup(doorId, groupId);
    } catch (error) {
      notifyError(error);
    }
  }, [account, doorId, groupId]);

  return (
    <Wrapper>
      {' '}
      {currentGroup?.permission === 'admin' ? (
        <Button
          themeOverrides={BUTTON_THEME2}
          expand
          onClick={handleRemoveDoorFromCustomGroup}
          style={{fontWeight: 600}}
        >
          <Translate value="remove_door_from_this_custom_group" />
        </Button>
      ) : (
        <></>
      )}
    </Wrapper>
  );
};

RemoveDoorFromCustomGroup.displayName = 'RemoveDoorFromCustomGroup';

const Wrapper = styled.div`
  display: flex;
`;
